<template>
  <div class="stage">
    <div class="stage__inner stage__inner-tree" v-if="clientWidth >= 992" :style="{transform: yPos(step)}">
      <Treeframe v-for="n in total" :key="n" :step="n" />
    </div>
    <div class="stage__inner stage__inner-grass" :style="{transform: yPos(step)}">
      <Grassmaker v-for="n in total" :key="n" :class="'ss_'+n"/>
    </div>
  </div>
</template>

<script>
import Grassmaker from './Grassmaker'
import Treeframe from './Treeframe'
export default {
  name: 'Grasscontrol',
  props: {
    total: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      clientWidth: null
    }
  },
  created () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    yPos (i) {
      return `translateX(-${100 * i}vw)`
    },
    onResize () {
      this.clientWidth = window.innerWidth
    }
  },
  components: {
    Grassmaker,
    Treeframe
  },
  mounted () {
    this.clientWidth = window.innerWidth
  }
}
</script>

<style lang="scss" scoped>
.stage {
    position: absolute;
    width: 100%;
    height: 100%;
    // background: AntiqueWhite;
    // pointer-events: none;
    overflow: hidden;
    &__inner {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      will-change: transform;
      &-tree {
        z-index: -2;
        transition: map-get($time, "l") .2s map-get($ease, "IOquad");
      }
      &-grass {
        transition: map-get($time, "l") map-get($ease, "IOquad");
        &-1 {
          transition-delay: .2s;
        }
        &-2 {
          transition-delay: .4s;
        }
      }
    }
}
</style>
